import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMarineSensingTechnologies = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 55,
	height: 55,
	viewBox: "0 0 55 55",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1238_22307)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M33.0701 15.73V16.82C33.0701 18.41 31.7801 19.71 30.1801 19.71C28.5801 19.71 27.2901 18.42 27.2901 16.82V15.73C20.9001 17.06 16.1001 22.73 16.1001 29.51C16.1001 36.29 20.9001 41.96 27.2901 43.29V42.11C27.2901 40.52 28.5801 39.22 30.1801 39.22C31.7801 39.22 33.0701 40.51 33.0701 42.11V43.29C39.4601 41.96 44.2601 36.29 44.2601 29.51C44.2601 22.73 39.4601 17.06 33.0701 15.73Z",
				fill: "#F7DD97"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.19 12.8396V13.8796C30.19 15.1096 29.44 16.2696 28.27 16.6496C26.27 17.2996 24.41 15.8296 24.41 13.9196V12.8296C18.02 14.1596 13.22 19.8296 13.22 26.6096C13.22 33.3896 18.02 39.0596 24.41 40.3896V39.2496C24.41 38.0196 25.16 36.8596 26.33 36.4796C28.33 35.8296 30.19 37.2996 30.19 39.2096V40.3896C36.58 39.0596 41.38 33.3896 41.38 26.6096C41.38 19.8296 36.58 14.1596 30.19 12.8296V12.8396Z",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.5302 28.1597C45.7502 38.0697 37.4602 45.8597 27.3602 45.8597C17.2602 45.8597 8.97019 38.0597 8.19019 28.1597",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.18018 25.0896C8.24018 24.3596 8.34018 23.6396 8.47018 22.9296C10.1002 14.5596 17.1502 8.12965 25.8202 7.44965C26.3302 7.40965 26.8402 7.38965 27.3502 7.38965C27.8602 7.38965 28.3702 7.40965 28.8802 7.44965C29.1602 7.46965 29.4402 7.49965 29.7202 7.52965C38.7202 8.63965 45.8002 15.9696 46.5202 25.0896",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.840088 9.94967C3.06009 6.46967 5.91009 3.50967 9.30009 1.15967",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.08008 11.9396C7.50008 9.71957 9.34008 7.80957 11.5001 6.30957",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.76 9.94967C51.54 6.46967 48.69 3.51967 45.3 1.15967",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.4901 11.9098C47.0901 9.71984 45.2701 7.81984 43.1301 6.33984",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.76 44.4097C51.54 47.8897 48.69 50.8397 45.3 53.1997",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.4901 42.4497C47.0901 44.6397 45.2701 46.5397 43.1301 48.0197",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.840088 44.4097C3.06009 47.8897 5.91009 50.8397 9.30009 53.1997",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.08008 42.4194C7.50008 44.6394 9.34008 46.5494 11.5001 48.0494",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.3402 27.0296C30.7402 27.0296 30.7402 25.7896 29.1302 25.7896C27.5202 25.7896 27.5202 27.0296 25.9202 27.0296C24.3202 27.0296 24.3102 25.7896 22.7102 25.7896",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.3402 30.2097C30.7402 30.2097 30.7402 28.9697 29.1302 28.9697C27.5202 28.9697 27.5202 30.2097 25.9202 30.2097C24.3202 30.2097 24.3102 28.9697 22.7102 28.9697",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.3402 23.8499C30.7402 23.8499 30.7402 22.6099 29.1302 22.6099C27.5202 22.6099 27.5202 23.8499 25.9202 23.8499C24.3202 23.8499 24.3102 22.6099 22.7102 22.6099",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1238_22307",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 54.6,
			height: 53.68,
			fill: "white",
			transform: "translate(0 0.339844)"
		})
	}) })]
});
export default SvgMarineSensingTechnologies;
